import { Component, computed, inject, Input } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-loader',
  imports: [],
  templateUrl: './loader.component.html',
})
export class LoaderComponent {

  private loaderService = inject(LoaderService);

  @Input() sectionId?: string;

  visible = computed(() => {
    
    if (this.sectionId) {
      return this.loaderService.isSectionLoading(this.sectionId);
    }
    return this.loaderService.isGlobalLoading();
  });

}
